import { intersectLineSegmentCircle } from "../intersect.mjs";
import { getArcMeasure, getPointInArcT, getPointOnCircle } from "../utils.mjs";
import { Vec } from "../Vec.mjs";
import { getVerticesCountForArcLength } from "./geometry-constants.mjs";
import { Geometry2d } from "./Geometry2d.mjs";
class Arc2d extends Geometry2d {
  _center;
  _radius;
  _start;
  _end;
  _largeArcFlag;
  _sweepFlag;
  _measure;
  _angleStart;
  _angleEnd;
  constructor(config) {
    super({ ...config, isFilled: false, isClosed: false });
    const { center, sweepFlag, largeArcFlag, start, end } = config;
    if (start.equals(end)) throw Error(`Arc must have different start and end points.`);
    this._angleStart = Vec.Angle(center, start);
    this._angleEnd = Vec.Angle(center, end);
    this._radius = Vec.Dist(center, start);
    this._measure = getArcMeasure(this._angleStart, this._angleEnd, sweepFlag, largeArcFlag);
    this._start = start;
    this._end = end;
    this._sweepFlag = sweepFlag;
    this._largeArcFlag = largeArcFlag;
    this._center = center;
  }
  nearestPoint(point) {
    const {
      _center,
      _measure: measure,
      _radius: radius,
      _angleEnd: angleEnd,
      _angleStart: angleStart,
      _start: A,
      _end: B
    } = this;
    const t = getPointInArcT(measure, angleStart, angleEnd, _center.angle(point));
    if (t <= 0) return A;
    if (t >= 1) return B;
    const dx = point.x - _center.x;
    const dy = point.y - _center.y;
    const len = Math.sqrt(dx * dx + dy * dy);
    if (len === 0) return A;
    const scale = radius / len;
    return new Vec(_center.x + dx * scale, _center.y + dy * scale);
  }
  hitTestLineSegment(A, B) {
    const {
      _center,
      _radius: radius,
      _measure: measure,
      _angleStart: angleStart,
      _angleEnd: angleEnd
    } = this;
    const intersection = intersectLineSegmentCircle(A, B, _center, radius);
    if (intersection === null) return false;
    return intersection.some((p) => {
      const result = getPointInArcT(measure, angleStart, angleEnd, _center.angle(p));
      return result >= 0 && result <= 1;
    });
  }
  getVertices() {
    const { _center, _measure: measure, length, _radius: radius, _angleStart: angleStart } = this;
    const vertices = [];
    for (let i = 0, n = getVerticesCountForArcLength(Math.abs(length)); i < n + 1; i++) {
      const t = i / n * measure;
      const angle = angleStart + t;
      vertices.push(getPointOnCircle(_center, radius, angle));
    }
    return vertices;
  }
  getSvgPathData(first = true) {
    const {
      _start: start,
      _end: end,
      _radius: radius,
      _largeArcFlag: largeArcFlag,
      _sweepFlag: sweepFlag
    } = this;
    return `${first ? `M${start.toFixed()}` : ``} A${radius} ${radius} 0 ${largeArcFlag} ${sweepFlag} ${end.toFixed()}`;
  }
  getLength() {
    return Math.abs(this._measure * this._radius);
  }
}
export {
  Arc2d
};
//# sourceMappingURL=Arc2d.mjs.map
